import { render } from "./SubTitleTypeComponent.vue?vue&type=template&id=0e557e50&scoped=true"
import script from "./SubTitleTypeComponent.vue?vue&type=script&lang=js"
export * from "./SubTitleTypeComponent.vue?vue&type=script&lang=js"

import "./SubTitleTypeComponent.vue?vue&type=style&index=0&id=0e557e50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e557e50"]])

export default __exports__